<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-6>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        class="nevigater-link"
        @click="$router.go(-1)"
      >
        <span v-if="$route.query.type === 'u'">
          จัดการผู้ใช้งาน
        </span>
        <span v-if="$route.query.type === 'a'">
          จัดการ admin
        </span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <span>ข้อมูลผู้ใช้งาน</span>
      </v-flex>
    </v-layout>

    <!-- Form -->
    <v-card tile>
      <!--            <v-divider style="background-color: #3E7662;border-width: 30px"></v-divider>-->
      <v-layout pl-6 py-2 style="background-color: #3E7662" class="py-4">
        <v-flex
          style="color: #ffff;text-align: left;font-weight: bold;font-size: 20px"
        >
          <span>ข้อมูลผู้ใช้งาน</span>
        </v-flex>
      </v-layout>
      <v-divider
        style="background-color: #544A44;border-width: 2px"
      ></v-divider>

      <!-- Form Data User -->
      <v-layout pa-6>
        <v-flex>
          <!-- VIEW USER -->
          <!-- <v-card tile> -->
          <v-layout style="background-color: #fff">
            <v-flex py-4 ml-12 style="text-align: left;">
              <v-layout>
                <v-flex>
                  <span style="font-weight: bold">ชื่อ-นามสกุล</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex pt-4>
                  <span style="font-weight: bold">(ภาษาไทย) : </span>
                  <span
                    >{{ formUser.preNameTh }}
                    {{ formUser.thName }}</span
                  >
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex pt-4>
                  <span style="font-weight: bold">(ภาษาอังกฤษ) : </span>

                  <span
                    >{{ formUser.preNameEn }}
                    {{ formUser.enName }}</span
                  >
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout style="background-color: #ffffff">
            <v-flex py-4 ml-12 style="text-align: left;">
              <v-layout>
                <v-flex>
                  <span style="font-weight: bold">เพศ</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="profile-style">
                  <span>{{ formUser.gender == 1 ? "ชาย" : formUser.gender == 2 ? "หญิง" : '-' }}</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout style="background-color: #ffffff">
            <v-flex py-4 ml-12 style="text-align: left;">
              <v-layout>
                <v-flex>
                  <span style="font-weight: bold">เบอร์โทรศัพท์มือถือ</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="profile-style">
                  <span>{{ formUser.mobilePhone }}</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout style="background-color: #fff">
            <v-flex py-4 ml-12 style="text-align: left;">
              <v-layout>
                <v-flex>
                  <span style="font-weight: bold">ประเภทผู้ใช้งาน</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex pt-4>
                  {{ checkType(formUser.isUser, "isUser") }}
                  {{ checkType(formUser.isStaff, "isStaff") }}
                  {{ checkType(formUser.isSecretary, "isSecretary") }}
                  {{ checkType(formUser.isReviewer, "isReviewer") }}
                  {{ checkType(formUser.isPresident, "isPresident") }}
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout style="background-color: #ffffff">
            <v-flex py-4 ml-12 style="text-align: left;">
              <v-layout>
                <v-flex>
                  <span style="font-weight: bold">Signature</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex pt-4>
                  <v-img
                    v-if="formUser.signatureImagePath"
                    style="border: 1px solid #000"
                    width="300"
                    contain
                    :src="formUser.signatureImagePath"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout
            style="background-color: #ffffff"
            v-if="formUser.isUser == 1"
          >
            <v-flex py-4 ml-12 style="text-align: left;">
              <v-layout>
                <v-flex>
                  <span style="font-weight: bold">ประวัติการศึกษา</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="profile-style">
                  <span>{{ formUser.education }}</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout style="background-color: #fff" v-if="formUser.isUser == 1">
            <v-flex py-4 ml-12 style="text-align: left;">
              <v-layout>
                <v-flex>
                  <span style="font-weight: bold">ประวัติการทำงาน</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="profile-style">
                  <span>{{ formUser.workEx }}</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <div v-if="formUser.isUser == 1 || formUser.isReviewer == 1">
            <v-layout style="background-color: #ffffff">
              <v-flex py-4 ml-12 style="text-align: left;">
                <v-layout>
                  <v-flex>
                    <span style="font-weight: bold">สาขาที่เชี่ยวชาญ</span>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex class="profile-style">
                    <span>
                      {{
                        formUser.scMastery ? formUser.scMastery !== "อื่นๆ" ? formUser.scMastery : formUser.otherScMastery
                          : formUser.field !== 'อื่นๆ' ? formUser.field : formUser.otherField
                      }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout style="background-color: #fff">
              <v-flex py-4 ml-12 style="text-align: left;">
                <v-layout>
                  <v-flex>
                    <span style="font-weight: bold">ตำแหน่งทางวิชาการ</span>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex class="profile-style">
                    <span>
                      {{
                      formUser.scPosition ? formUser.scPosition !== "อื่นๆ" ? formUser.scPosition : formUser.otherScPosition
                        : formUser.position !== "อื่นๆ" ? formUser.position : formUser.otherPosition
                    }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--สังกัด-->
            <v-layout style="background-color: #ffffff">
              <v-flex py-4 ml-12 style="text-align: left;">
                <v-layout>
                  <v-flex>
                    <span style="font-weight: bold">สังกัด</span>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex class="profile-style" v-if="formUser.isUser == 1">
                    <span v-if="formUser.affiliation">
                      {{ formUser.affiliation.affiliation === 'อื่นๆ' ? formUser.otherAffiliation : formUser.affiliation.affiliation }}
                    </span>
                  </v-flex>
                  <v-flex v-else>
                    <span v-if="formUser.scAffiliation">
                      {{
                        formUser.scAffiliation != 15
                          ? formUser.sc__affiliation.affiliation
                          : formUser.otherScAffiliation
                      }}
                    </span>
                  </v-flex>
                </v-layout>
                <div>
                  ({{
                    formUser.isScientist == 1 ? "Scientist" : "Non Scientist"
                  }}) ({{
                    formUser.isAffiliated == 1
                      ? "Affiliated"
                      : "Non Affiliated"
                  }})
                </div>
              </v-flex>
            </v-layout>
            <!--กอง-->
            <v-layout style="background-color: #fff">
              <v-flex py-4 ml-12 style="text-align: left;">
                <v-layout>
                  <v-flex>
                    <span style="font-weight: bold">กอง</span>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex class="profile-style">
                    <span>{{
                        formUser.scTeam ? formUser.scTeam !== "อื่นๆ" ? formUser.scTeam : formUser.otherScTeam
                            : formUser.team !== "อื่นๆ" ? formUser.team : formUser.otherTeam
                      }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--คำสั่งแต่งตั้ง-->
            <v-layout style="background-color: #ffffff">
              <v-flex py-4 ml-12 style="text-align: left;">
                <v-layout>
                  <v-flex>
                    <span style="font-weight: bold">คำสั่งแต่งตั้ง</span>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    เลขที่คำสั่ง
                    {{ formUser.orderNumber }} แต่งตั้งเมื่อวันที่
                    {{ changeDate(formUser.orderDate) }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout
              style="background-color: #fff"
              v-if="formUser.isUser == 1"
            >
              <v-flex py-4 ml-12 style="text-align: left;">
                <v-layout>
                  <v-flex>
                    <span style="font-weight: bold">สถานที่ติดต่อ</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-2>
                  <v-flex class="profile-style">
                    <span>
                      บ้านเลขที่ {{ formUser.houseNumber ? formUser.houseNumber : '-' }} ถนน
                      {{ formUser.road ? formUser.road : '-' }} เเขวง {{ formUser.subDistrict ? formUser.subDistrict : '-' }} เขต
                      {{ formUser.district ? formUser.district : '-' }} จังหวัด
                      {{ formUser.province ? formUser.province : '-' }} รหัสไปรษณีย์
                      {{ formUser.postalCode ? formUser.postalCode : '-' }}</span
                    >
                  </v-flex>
                </v-layout>
                <v-layout mt-2>
                  <v-flex class="profile-style">
                    <span>โทรศัพท์ที่บ้าน {{ formUser.telPhone }}</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-2>
                  <v-flex class="profile-style">
                    <span>โทรศัพท์ที่มือถือ {{ formUser.mobilePhone }}</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-2>
                  <v-flex class="profile-style">
                    <span>E-mail Address {{ formUser.email }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout
              style="background-color: #ffffff"
              v-if="formUser.isUser == 1"
            >
              <v-flex py-4 ml-12 style="text-align: left;">
                <v-layout>
                  <v-flex>
                    <span style="font-weight: bold">
                      ประวัติการอบรม Good Clinical Practice (GCP)
                      หรือการอบรมด้านจริยธรรมการวิจัยในมนุษย์
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex class="profile-style">
                    <span>{{ formUser.practiceEx }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout v-else>
              <v-flex py-4 ml-12 style="text-align: left;">
                <v-layout>
                  <v-flex>
                    <span style="font-weight: bold">
                      การเข้ารับการอบรม
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout v-for="item in formUser.sc_training" :key="item.id">
                  <v-flex xs6> ชื่อการอบรม : {{ item.trainingName }} </v-flex>
                  <v-flex xs6>
                    วันที่เข้าอบรม: {{ changeDate(item.trainingDate) }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
          <!-- </v-card> -->
        </v-flex>
      </v-layout>

      <v-divider
        style="background-color: #544A44;border-width: 2px"
      ></v-divider>
    </v-card>

    <!-- <pre class="text-start">{{ formUser }}</pre> -->

    <!-- Button -->
    <v-layout mt-12>
      <v-flex mr-8 d-flex justify-end>
        <v-btn color="#FFFFFF" @click="$router.go(-1)">
          <span style="color: #3E7662;font-weight: bold">ย้อนกลับ</span>
        </v-btn>
      </v-flex>
      <v-flex mr-12 shrink d-flex justify-end>
        <v-btn color="#CC3D45" dark
          ><span style="font-weight: bold" @click="deleteUser"
            >ลบข้อมูล</span
          ></v-btn
        >
      </v-flex>
    </v-layout>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import TextareaForm from "../../components/input/TextareaForm";
import DateInputForm from "../../components/input/DateInputForm";
import { VueEditor } from "vue2-editor";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapState } from "vuex";

export default {
  name: "CreateNews",
  components: {
    TextareaForm,
    VueEditor,
    DateInputForm,
    Loading,
  },
  data: () => ({
    id: "",
    isLoading: false,
    fullPage: true,
  }),
  created() {
    this.id = this.$route.query.id;
    this.getUser(this.id);
  },
  computed: {
    ...mapState({
      formUser: (state) => state.User.formUser,
    }),
  },
  methods: {
    changeDate(val) {
      if (val) {
        let sub_year = val.substring(0, 4);
        let sub_month = val.substring(5, 7);
        let sub_day = val.substring(8, 10);
        sub_year = parseInt(sub_year) + 543;
        let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
        return changeDate;
      } else {
        return "";
      }
    },
    checkType(type, text) {
      if (type == 1) {
        switch (text) {
          case "isUser":
            return "นักวิจัย ";
          case "isStaff":
            return "เจ้าหน้าที่ ";
          case "isSecretary":
            return "เลขานุการ ";
          case "isReviewer":
            return "คณะอนุกรรมการ ";
          case "isPresident":
            return "ประธาน";
        }
      } else {
        return "";
      }
    },
    async getUser(id) {
      this.isLoading = true;
      const res = await this.$store.dispatch("User/getUserById", id);
      // this.formUser = res;
      this.isLoading = false;
    },
    deleteUser() {
      Swal.fire({
        title: "คุณต้องการลบข้อมูลหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ต้องการ",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("Auth/delete", this.id)
            .then(() => {
              Swal.fire({
                title: "ลบข้อมูลเรียบร้อยแล้ว",
                icon: "success",
                position: "center",
                showConfirmButton: false,
                timer: 1500,
                background: "#fffff",
              });
              this.$router.push("/user-management");
            })
            .catch((e) => {
              // console.log(e.response.status)
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: "เกิดข้อผิดพลาด",
              //     text: "บันทึกไม่สำเร็จ",
              //     icon: 'warning',
              //     confirmButtonColor: '#3E7662'
              // });
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.upload-image {
  padding: 50px 50px 50px 50px;
  font-weight: bold;
  border-style: dashed;
  border-width: 2px;
  border-color: #000;
}
</style>
